import { Outlet, Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { LogOut, LayoutDashboard, Settings } from "lucide-react";
import { useEffect, useState } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AdminLayout = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);

  useEffect(() => {
    // Check auth
    const token = localStorage.getItem("adminToken");
    if (!token) {
      navigate("/admin");
      return;
    }

    // Verify token
    fetch(`${API}/admin/me`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => {
        if (!res.ok) throw new Error("Unauthorized");
        return res.json();
      })
      .then((data) => setUser(data))
      .catch(() => {
        localStorage.removeItem("adminToken");
        navigate("/admin");
      });
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem("adminToken");
    navigate("/admin");
  };

  if (!user) {
    return (
      <div className="min-h-screen bg-[color:var(--pws-cream)] flex items-center justify-center">
        <div className="animate-pulse text-[color:var(--pws-stone)]">Loading...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[color:var(--pws-cream)]">
      {/* Admin Header */}
      <header className="bg-[color:var(--pws-charcoal)] text-white" data-testid="admin-header">
        <div className="container-pws py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-6">
              <Link
                to="/admin/dashboard"
                className="font-['Space_Grotesk'] text-lg font-semibold"
                data-testid="admin-logo"
              >
                PWS Admin
              </Link>
              <nav className="hidden md:flex items-center gap-4">
                <Link
                  to="/admin/dashboard"
                  className="flex items-center gap-2 text-sm text-white/80 hover:text-white transition-colors"
                  data-testid="admin-nav-dashboard"
                >
                  <LayoutDashboard className="h-4 w-4" />
                  Dashboard
                </Link>
              </nav>
            </div>
            <div className="flex items-center gap-4">
              <span className="text-sm text-white/70" data-testid="admin-user-email">
                {user.email}
              </span>
              <span className="text-xs px-2 py-1 rounded bg-white/10" data-testid="admin-user-role">
                {user.role}
              </span>
              <Button
                variant="ghost"
                size="sm"
                onClick={handleLogout}
                className="text-white/80 hover:text-white hover:bg-white/10"
                data-testid="admin-logout-btn"
              >
                <LogOut className="h-4 w-4 mr-2" />
                Logout
              </Button>
            </div>
          </div>
        </div>
      </header>

      {/* Admin Content */}
      <main className="container-pws py-8">
        <Outlet context={{ user }} />
      </main>
    </div>
  );
};

export default AdminLayout;
